import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

type MuiRadioGroupProps = {
  label?: string;
  name: string;
  value: string;
  options?: { value: string; label: string }[];
  direction?: "row" | "column";
  isInvalid?: boolean;
  errorText?: string;
  isRequired?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
  variant?: "withLabel" | "withOutLabel";
};

const MuiRadioButton: React.FC<MuiRadioGroupProps> = ({
  label,
  name,
  value,
  options = [],
  direction = "column",
  isInvalid = false,
  errorText = "",
  isRequired = false,
  disabled = false,
  onChange,
  variant = "withLabel",
}) => {
  return (
    <FormControl component="fieldset" error={isInvalid} required={isRequired} disabled={disabled}>
      {/* Show label only if variant is withLabel */}
      {variant === "withLabel" && label && <FormLabel component="legend">{label}</FormLabel>}

      {/* Render multiple options if "withLabel", otherwise a single radio button */}
      {variant === "withLabel" ? (
        <RadioGroup
          row={direction === "row"}
          name={name}
          value={value}
          onChange={(e) => onChange?.(e.target.value)} // ✅ Correctly extracts the value
        >
          {options.map((option) => (
            <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} />
          ))}
        </RadioGroup>
      ) : (
        <FormControlLabel
          control={<Radio checked={value === "selected"} onChange={() => onChange?.("selected")} />} // ✅ Fixed issue
          label={label || ""}
        />
      )}

      {/* Show error message if invalid */}
      {isInvalid && <p style={{ color: "red", fontSize: "0.8rem", margin: "4px 0 0" }}>{errorText}</p>}
    </FormControl>
  );
};

export default MuiRadioButton;
